
function DEF(a,def) {
    return this.hasOwnProperty(a) ? this[a] : def;
}



function start() {


    startGame();
}



